import React from "react";
import { Stack, useTheme, Box } from "@mui/material";
import Tooltip from "@hyro-components/Tooltip";
import HyroTruncateTypography from "@hyro-components/hyro-truncate-typography/HyroTruncateTypography";
import CampaignQuestionIcon from "src/icons/CampaignQuestionIcon";

const FieldWrapper = ({ children, label, required, description, tooltip, showTopSection = false, wrapperSx, wrapperTooltip }) => {
  const theme = useTheme();

  if (!showTopSection) return children;
  return <Stack sx={{ maxWidth: 550 }}>
    <Box mb={1.5}>
      {label && <Stack direction="row" alignItems="center" gap={1}>
        <HyroTruncateTypography variant="subtitle2" maxWidth="50ch" sx={{ color: "text.primary" }}>
          {label}{required ? <span style={{ marginLeft: "4px", color: theme.palette.error[500] }}>*</span> : ""}
        </HyroTruncateTypography>
        {tooltip ? <Tooltip
          variant="light"
          title={tooltip}
          tooltipStyle={{ width: 330 }}
        >
          <Box sx={{ width: 14, height: 14 }} display={"flex"} alignItems={"center"}>
            <CampaignQuestionIcon color={theme.palette.system[700]} />
          </Box>
        </Tooltip> : null}
      </Stack>}
      {description && <HyroTruncateTypography variant="body2" maxWidth="120ch" lines={2} sx={{ color: "text.700" }}>{description}</HyroTruncateTypography>}
    </Box>
    <Box sx={{ ...wrapperSx }}>
      {wrapperTooltip ? <TooltipWrapper tooltip={wrapperTooltip}>{children}</TooltipWrapper> : children}
    </Box>
  </Stack>;
};

const TooltipWrapper = ({ children, tooltip }) => (
  <Tooltip title={tooltip} popperStyle={{ marginBottom: "-10px" }}>
    {children}
  </Tooltip>
);

export default FieldWrapper;
